<template>
  <div>
    <div class="back" v-on:click="goBack">
      Back to Dashboard
    </div>

    <div class="screen-count-container">
      <h3>Active Screens</h3>
      <span class="screen-count">{{activeScreens}}</span>
    </div>

    <div class="screen-count-container">
      <h3>Available Screens</h3>
      <span class="screen-count">{{availableScreens}}</span>
    </div>

    <div class="new-screen-container">
      <h3>Purchase Screens</h3>
      <hr>
      <div class="slider-container">
        <label>Number of Additional Screens:</label>
        <div class="screen-count">
          {{additionalScreens}}
        </div>
        <input type="range" min="1" max="50" value="1" class="slider" v-model="additionalScreens">
      </div>
    </div>

    <stripe-checkout
        ref="checkoutRef"
        mode="subscription"
        :pk="publishableKey"
        :line-items="lineItems"
        :success-url="successUrl"
        :cancel-url="cancelUrl"
        @loading="v => loading = v"
      />
      <button class="button" v-on:click="checkout">
        Checkout
      </button>
  </div>
</template>

<script>
import '../styles/base.css'
import { StripeCheckout } from '@vue-stripe/vue-stripe'

export default {
  name: 'Subscribe',

  components: {
    StripeCheckout
  },

  data () {
    return {
      activeScreens: 4,
      additionalScreens: 1,
      availableScreens: 0,
      loading: false,
      publishableKey: 'pk_test_TwlOAg2mP8V9MTirnQJJ8Y1s00xw550DHJ',
      lineItems: [
        {
          price: 'price_1Je9v8EFGqRLasuWZKeAKMGD',
          quantity: 1
        }
      ],
      successUrl: PS.SITE_BASE_URL,
      cancelUrl: PS.SITE_BASE_URL + '/dashboard'
    }
  },

  methods: {
    checkout: function () {
      this.lineItems[0].quantity = parseInt(this.additionalScreens)
      this.$refs.checkoutRef.redirectToCheckout()
    },

    goBack: function () {
      this.$parent.setSelectedPane('slide-builder')
    }
  }
}
</script>

<style scoped>
  .button {
    color: white;
    font-size: 1.2em;
    margin: 1em;
    padding: 1em;
    width: 300px;
  }

  h3 {
    margin: 0;
  }

  hr {
    background: var(--border-grey);
    height: 1px;
    width: 100%;
  }

  .new-screen-container {
    background: white;
    border: 1px solid var(--border-grey);
    border-radius: 6px;
    justify-content: space-around;
    margin: 1em;
    padding: 1em;
    width: 612px;
  }

  .slider-container {
    margin-top: 1em;
    width: 100%;
  }

  .slider {
    -webkit-appearance: none;
    appearance: none;
    background: #d3d3d3;
    border-radius: 5px;
    height: 15px;
    margin-top: 1.25em;
    transition: opacity .2s;
    outline: none;
    opacity: 0.7;
    width: 100%;
    -webkit-transition: .2s;
  }

  .slider:hover {
    opacity: 1;
  }

  .slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    background: var(--secondary);
    border-radius: 50%;
    cursor: pointer;
    height: 35px;
    width: 35px;
  }

  .slider::-moz-range-thumb {
    background: var(--secondary);
    cursor: pointer;
    height: 25px;
    width: 25px;
  }

  .screen-count {
    color: var(--secondary);
    font-size: 3.5em;
  }

  .screen-count-container {
    background: white;
    border: 1px solid var(--border-grey);
    border-radius: 6px;
    display: inline-block;
    height: 140px;
    justify-content: space-around;
    margin: 1em;
    padding: 1em;
    width: 288px;
  }

  span {
    color: var(--secondary);
  }

  @media only screen and (max-width: 676px) {
    .button {
      width: 284px;
    }

    .new-screen-container {
      width: 288px;
    }
  }
</style>
